import { render, staticRenderFns } from "./RateiosTabela.vue?vue&type=template&id=60b45224&"
import script from "./RateiosTabela.vue?vue&type=script&lang=js&"
export * from "./RateiosTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports